export const navItems = [
  { label: "首页", href: "#top" },
  { label: "实锤现场", href: "#gallery" },
  { label: "聊天记录", href: "#records" },
  { label: "热议榜", href: "#ranking" },
  { label: "图集速览", href: "#overview" },
  { label: "下载", href: "#download" },
];

export const focusItems = [
  {
    id: "f1",
    tag: "今日封面",
    title: "某综艺后台录音流出，三段对话前后对不上",
    summary:
      "同一时段的三份聊天记录被摆在一起，时间戳与在场人员名单出现明显出入，编辑部已按时间线重新梳理。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20style%20abstract%20collage%20of%20warm%20cream%20paper%20texture%20and%20crimson%20torn%20paper%20strips%20overlapping%20with%20soft%20natural%20light%20and%20fine%20grain%2C%20minimalist%20art%20direction%2C%20high%20detail%2C%20harmonious%20warm%20tones&width=1200&height=900&seq=hl-cover-main-01&orientation=landscape",
    time: "2 小时前",
    views: "48.6 万",
  },
  {
    id: "f2",
    tag: "截图实录",
    title: "直播间口误合集：三个版本说法同一句话",
    summary:
      "剪辑时间线被用户逐帧截图对照，弹幕与后台回复的先后顺序成了新的讨论焦点。",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20still%20life%20of%20stacked%20warm%20beige%20paper%20cards%20and%20crimson%20seal%20stamp%20on%20a%20cream%20desk%2C%20soft%20diffused%20daylight%2C%20fine%20paper%20grain%2C%20muted%20warm%20palette%2C%20clean%20composition%2C%20high%20detail&width=900&height=900&seq=hl-cover-side-01&orientation=squarish",
    time: "5 小时前",
    views: "21.3 万",
  },
  {
    id: "f3",
    tag: "证据链",
    title: "品牌方与主播的合作时间线被完整还原",
    summary:
      "合同截图、发布记录、下架时间三类材料已经对齐，关键节点用图片逐张标注。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20magazine%20layout%20of%20overlapping%20timeline%20cards%20in%20warm%20sand%20and%20deep%20crimson%20on%20cream%20background%2C%20soft%20studio%20light%2C%20subtle%20paper%20texture%2C%20minimal%20editorial%20art%20direction%2C%20high%20detail&width=900&height=900&seq=hl-cover-side-02&orientation=squarish",
    time: "昨天",
    views: "33.9 万",
  },
];

export const galleryItems = [
  {
    id: "g1",
    tag: "图集",
    count: "24 张",
    title: "现场原图：从入场到离场全过程",
    summary: "按拍摄时间排列的连续原图，附每一张的拍摄地点备注。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photo%20contact%20sheet%20of%20abstract%20warm%20toned%20frames%20with%20crimson%20accents%20on%20cream%20paper%2C%20fine%20film%20grain%2C%20soft%20natural%20light%2C%20minimalist%20magazine%20art%20direction%2C%20high%20detail&width=800&height=1000&seq=hl-gal-01&orientation=portrait",
  },
  {
    id: "g2",
    tag: "对比",
    count: "18 张",
    title: "两个版本的说法逐句对照",
    summary: "同一问题的两次回应被并排放大，差异处用框线标出。",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20comparison%20board%20with%20two%20warm%20beige%20paper%20panels%20and%20crimson%20highlight%20lines%20on%20cream%20surface%2C%20soft%20daylight%2C%20subtle%20texture%2C%20clean%20composition%2C%20high%20detail&width=800&height=1000&seq=hl-gal-02&orientation=portrait",
  },
  {
    id: "g3",
    tag: "截图",
    count: "31 张",
    title: "聊天窗口高清截图打包",
    summary: "头部信息与时间戳保留原样，长图分段高清导出。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20stack%20of%20warm%20cream%20chat%20bubble%20shapes%20in%20sand%20tones%20with%20crimson%20dots%2C%20soft%20studio%20light%2C%20paper%20grain%2C%20minimal%20magazine%20style%2C%20high%20detail&width=800&height=1000&seq=hl-gal-03&orientation=portrait",
  },
  {
    id: "g4",
    tag: "时间线",
    count: "12 张",
    title: "事件七十二小时关键节点图",
    summary: "把三天内的公开动态压缩成一张可放大查看的长图。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20vertical%20timeline%20graphic%20with%20warm%20bronze%20dots%20and%20lines%20on%20cream%20paper%2C%20soft%20diffused%20light%2C%20subtle%20texture%2C%20minimal%20art%20direction%2C%20high%20detail&width=800&height=1000&seq=hl-gal-04&orientation=portrait",
  },
];

export const rankingItems = [
  {
    rank: 1,
    title: "某主播连麦失控片段被反复截图",
    summary: "三段不同机位素材被剪成一张对照长图，讨论度持续走高。",
    tag: "热",
    heat: "98.2 万",
  },
  {
    rank: 2,
    title: "剧组通告单流出，档期前后矛盾",
    summary: "通告单与行程截图放在一起，被指出存在时间重叠。",
    tag: "新",
    heat: "76.4 万",
  },
  {
    rank: 3,
    title: "品牌解约声明与旧海报同框对比",
    summary: "解约时间与上一轮宣传物料发布时间被逐条列出。",
    tag: "证",
    heat: "65.1 万",
  },
  {
    rank: 4,
    title: "采访原片与成片台词出入明显",
    summary: "原片截图与播出版本并列，逐句差异用下划线标出。",
    tag: "鉴",
    heat: "52.8 万",
  },
  {
    rank: 5,
    title: "粉丝群管理员聊天记录被整理",
    summary: "按日期归档的群聊截图，关键发言单独放大。",
    tag: "图",
    heat: "44.6 万",
  },
  {
    rank: 6,
    title: "旧动态编辑记录被逐条还原",
    summary: "发布时间与编辑时间被排列成一张可追溯的表格图。",
    tag: "梳",
    heat: "31.7 万",
  },
];

export const chatRecords = [
  {
    id: "c1",
    title: "一段被删除又恢复的对话",
    summary:
      "对话双方的昵称与头像做了遮挡处理，时间戳与撤回提示保留原样，可放大查看每一句的先后顺序。",
    tag: "聊天记录",
    time: "06-18 21:40",
    lines: 42,
  },
  {
    id: "c2",
    title: "工作群里关于改稿的分歧",
    summary:
      "围绕同一版文案的来回修改被完整截取，前后两个版本的差异用底色标出，方便逐行对照。",
    tag: "群聊截图",
    time: "06-19 09:12",
    lines: 27,
  },
  {
    id: "c3",
    title: "语音转文字与原始录音对照",
    summary:
      "转写文本按时间轴铺开，与原始音频波形一并呈现，标出容易被误读的几处停顿和语气词。",
    tag: "录音转写",
    time: "06-20 14:05",
    lines: 63,
  },
];

export const categoryTags = [
  "实锤截图",
  "聊天记录",
  "证据截图",
  "爆料截图",
  "现场原图",
  "时间线梳理",
  "对比图集",
  "采访原片",
];

export const overviewItems = [
  {
    id: "o1",
    title: "高清原图放大不糊",
    summary: "原图按长边压缩保留细节，双击即可放大查看局部。",
    tag: "原图",
  },
  {
    id: "o2",
    title: "截图上下一键对照",
    summary: "左右分屏摆放两张截图，差异处自动高亮标线。",
    tag: "对照",
  },
  {
    id: "o3",
    title: "时间戳自动归档",
    summary: "按时间排列图集，快速定位关键节点前后发生了什么。",
    tag: "归档",
  },
  {
    id: "o4",
    title: "图集打包离线看",
    summary: "选定图集后可整包缓存，通勤路上也能慢慢翻。",
    tag: "下载",
  },
  {
    id: "o5",
    title: "关键信息快速锁定",
    summary: "每张截图配一句短摘要，扫一眼就知道重点在哪。",
    tag: "速读",
  },
  {
    id: "o6",
    title: "来源标注更清楚",
    summary: "每组图集都标注整理时间与来源类型，方便回查。",
    tag: "溯源",
  },
];

export const faqItems = [
  {
    q: "「黑料图片」主要放什么内容？",
    a: "以实锤截图、聊天记录与证据截图三类图片为主，配合一句短摘要，帮你在扫图时快速锁定关键信息。",
  },
  {
    q: "图集可以整包下载吗？",
    a: "可以。选定图集后支持整包缓存，方便离线慢慢翻；下载与入口在首屏和页面下方都有明显提示。",
  },
  {
    q: "截图会做遮挡处理吗？",
    a: "涉及个人昵称、头像等非必要信息时统一做遮挡处理，只保留与事件本身相关的对话与时间戳。",
  },
  {
    q: "内容多久更新一次？",
    a: "现场原图与证据截图持续更新，热议榜与今日焦点会随讨论度变化重新排序。",
  },
];

export const footerLinks = [
  { label: "实锤现场", href: "#gallery" },
  { label: "聊天记录", href: "#records" },
  { label: "热议榜", href: "#ranking" },
  { label: "图集速览", href: "#overview" },
  { label: "常见问题", href: "#faq" },
];